<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 3.main-container-start -->
    <div class="main">
		<div class="df-maina-ddtit"><span>账单详情</span>
		<el-button
		  size="small"
		  style="width:90px;background:#9cbbd8;color:#fff;margin-left:50px;"
		  @click="goBack"
		>
		  返 回
		</el-button></div>
        

      <div class="bottom">
        <div class="top">
          <div class="line flexStyle2">
            <div class="item flexStyle2">
              <div class="left">客户名称:</div>
              <div class="right">{{ obj.customerName || "暂无" }}</div>
            </div>
            <div class="item flexStyle2">
              <div class="left">本月消费总额:</div>
              <div class="right">{{ obj.deductionMoney || "--" }}</div>
            </div>
          </div>
          <div class="line flexStyle2">
            <div class="item flexStyle2">
              <div class="left">手机号码:</div>
              <div class="right">{{ obj.cellPhone || "暂无" }}</div>
            </div>
            <div class="item flexStyle2">
              <div class="left">本月剩余余额:</div>
              <div class="right">{{ obj.balance || "--" }}</div>
            </div>
          </div>
          <div class="line flexStyle2">
            本月账户余额:
            <span class="empty"></span>
            {{ obj.balance || "--" }}
            <span class="empty"></span>
            =
            <span class="empty"></span>
            上月账户余额:{{ obj.firstBalance || "--" }}
            <span class="empty"></span>
            +
            <span class="empty"></span>
            本月入账总额:{{ obj.rechargeMoney || "--" }}
            <span class="empty"></span>
            -
            <span class="empty"></span>
            本月消费总额:{{ obj.deductionMoney || "--" }}
          </div>
        </div>
        <div class="bottom">
          <el-table
            :data="currentPageInfo"
            style="width: 100%"
            :cell-style="{
                'text-align':'center',
                'border-color':'#dbdbdb',
                'position':'relative',
				'background-color': '#f3f1f2',
                'border-right':'1px solid #e7e6e4'
            }"
            :header-cell-style="{
				'background-color': '#b6b6b6',
				'color': '#000',
                'fontSize':'14px',
                'fontWeight':'300',
                'text-align':'center'
            }"
          >
            <el-table-column prop="num" align="center" label="序号" width="65">
              <template slot-scope="scope">
                {{ (scope.$index + 1) }}
              </template>
            </el-table-column>
            <el-table-column prop="orderNum" label="订单编号" min-width="130">
              <template slot-scope="scope">
                {{ scope.row.orderNum }}
              </template>
            </el-table-column>

            <el-table-column
              prop="goodsDetail"
              label="商品信息"
              min-width="300"
            >
              <template slot-scope="scope">
                {{ scope.row.goodsDetail || "" }}
              </template>
            </el-table-column>

            <el-table-column prop="consignee" label="收货人" min-width="160">
              <template slot-scope="scope">
                {{ scope.row.consignee || "" }}
              </template>
            </el-table-column>

            <el-table-column prop="status" label="状态" min-width="100">
              <template slot-scope="scope">
                <span>{{ order_status(scope.row.status) || "" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="moneyGoods"
              min-width="120"
              label="商品金额"
              align="right"
            >
              <template slot-scope="scope">
                ¥{{ to_f(scope.row.moneyGoods || "0.00") }}
              </template>
            </el-table-column>
            <el-table-column
              prop="moneyYun"
              min-width="120"
              label="运费"
              align="right"
            >
              <template slot-scope="scope">
                ¥{{ to_f(scope.row.moneyGoods || "0.00") }}
              </template>
            </el-table-column>

            <el-table-column
              prop="money"
              min-width="120"
              label="总额"
              align="right"
            >
              <template slot-scope="scope">
                ¥{{ to_f(scope.row.money || "0.00") }}
              </template>
            </el-table-column>
          </el-table>
          <br /><br />
          <div class="hands order flexStyle2 borderShadow">
            <div class="item">
              <span></span>
            </div>
            <div class="item oneLine">
              <span></span>
            </div>
            <div class="item">
              <span></span>
            </div>
            <div class="item oneLine">
              <span></span>
            </div>
            <div class="item oneLine">
              <span>合计：</span>
            </div>
            <div class="item oneLine">
              <span>¥{{ sumMoneyGoods || "0.00" }}</span>
            </div>
            <div class="item oneLine">
              <span>¥{{ sumMoneyYun || "0.00" }}</span>
            </div>
            <div class="item oneLine">
              <span>¥{{ sumMoney || "0.00" }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="button hands c-animation2" style="display:none;">
        导出EXCEL
      </div>
    </div>
    <!-- 3.main-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { orderEveryRequest } from "../../public/js/service";
import * as math from "mathjs";

export default {
  data() {
    // 1.data
    return {
      token: "", // 1.2.token
      id: "", // 1.3.id
      obj: {},
      result: "",
      sumMoneyGoods: 0.0,
      sumMoneyYun: 0.0,
      sumMoney: 0.0,
      currentPageInfo: {},
    };
  },
  components: {},
  methods: {
    // 3.methods
    goBack() {
      // 3.1.返回
      this.$router.push("/financeCenter?buttonsIndex=5");
    },
    getCurrentPageInfo() {
      // 3.2.获取信息
      orderEveryRequest(this.id).then((res) => {
        if (res) {
          this.currentPageInfo = res.data;
          this.sumMoney = this.totalMoney();
          this.sumMoneyYun = this.totalYF();
          this.sumMoneyGoods = this.totalGoods();
        }
      });
    },
    printFn(value) {
      // 3.12.精度算数
      const precision = 14;
      return Number(math.format(value, precision));
    },
    totalGoods() {
      let res = 0;
      this.currentPageInfo.forEach((item) => {
        res += item.moneyGoods;
      });
      return this.printFn(res);
    },

    totalYF() {
      let res = 0;
      this.currentPageInfo.forEach((item) => {
        res += item.moneyYun;
      });
      return this.printFn(res);
    },

    totalMoney() {
      let res = 0;
      this.currentPageInfo.forEach((item) => {
        res += item.money;
      });
      return this.printFn(res);
    },
  },
  mounted() {
    if (this.$route.query.obj) {
      this.obj = JSON.parse(decodeURIComponent(this.$route.query.obj));
      this.id = this.obj.id;
      if (localStorage.token) {
        this.token = localStorage.token;
        this.getCurrentPageInfo();
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "./everyOrderDetail.scss";
</style>
